// extracted by mini-css-extract-plugin
export default {"input":"input_input__ytaQa","label":"input_label__6YQUy"};